// extracted by mini-css-extract-plugin
export default {"cards":"Documents_cards__ZpyWQ","content":"Documents_content__6-CVq"};